import { useEffect, useRef, useState } from 'react'
import { Download, Printer, QrCode } from 'lucide-react'
import QRCode from 'qrcode'
import { buildStationUrl, isLocalPublicOrigin, resolvePublicOrigin } from '../../lib/qr'

const stations = ['Station 1', 'Station 2', 'Station 3']

export function QrStudio() {
  const [selected, setSelected] = useState('Station 3')
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const configuredOrigin = import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined
  const publicOrigin = resolvePublicOrigin(window.location.origin, configuredOrigin)
  const previewOnly = isLocalPublicOrigin(publicOrigin)
  const stationUrl = buildStationUrl(publicOrigin, selected)

  useEffect(() => {
    if (canvasRef.current) QRCode.toCanvas(canvasRef.current, stationUrl, { width: 216, margin: 2, color: { dark: '#201721', light: '#fbf7ef' } })
  }, [stationUrl])

  const download = () => {
    const link = document.createElement('a')
    link.download = `${selected.toLowerCase().replaceAll(' ', '-')}-spellbound-qr.png`
    link.href = canvasRef.current?.toDataURL('image/png') ?? ''
    link.click()
  }

  return (
    <div className="staff-view">
      <div className="staff-view__heading"><div><p className="eyebrow">Station access</p><h1>QR studio</h1><p>Create a unique concierge link for each configured chair.</p></div></div>
      <div className={`qr-origin-note ${previewOnly ? 'qr-origin-note--warning' : ''}`}><strong>{previewOnly ? 'Preview URL only' : 'Public QR destination'}</strong><span>{previewOnly ? 'Set VITE_PUBLIC_SITE_URL to the final HTTPS domain before downloading or printing cards.' : publicOrigin}</span></div>
      <div className="qr-layout">
        <section className="station-list"><h2>Salon stations</h2>{stations.map((station) => <button className={selected === station ? 'active' : ''} key={station} onClick={() => setSelected(station)}><QrCode size={18} /><span><strong>{station}</strong><small>?station={encodeURIComponent(station)}</small></span></button>)}</section>
        <section className="qr-card">
          <div className="qr-card__ornament">✦ · ☾ · ✦</div>
          <p>Spellbound Salon</p><h2>A little luxury<br />at your fingertips.</h2>
          <div className="qr-code"><canvas ref={canvasRef} aria-label={`QR code for ${selected}`} /></div>
          <strong>{selected}</strong><span>Scan to request amenities, comfort, or upgrades.</span>
          <div className="qr-actions"><button onClick={download} disabled={previewOnly} title={previewOnly ? 'Configure the final public URL first' : undefined}><Download size={17} />Download PNG</button><button onClick={() => window.print()} disabled={previewOnly} title={previewOnly ? 'Configure the final public URL first' : undefined}><Printer size={17} />Print card</button></div>
        </section>
      </div>
    </div>
  )
}
